import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLinkExternalComponent } from "./med-icon-link-external.component";

@NgModule({
  declarations: [
    MedIconLinkExternalComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLinkExternalComponent,
  ],
})
export class MedIconLinkExternalModule { }
